import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class MenuUtility {
    menuState$ = new Subject<boolean>();
    requestClose$ = new BehaviorSubject<boolean>(false);
    menuOpen$ = new Subject<{ isOpen: boolean; hasSecondaryNav: boolean }>();

    /**
     * Update menu state
     *
     * @param {boolean} isOpened menu opening state
     */
    updateMenuState(isOpened = false) {
        this.menuState$.next(isOpened);
    }

    /**
     * open menu
     */
    openMenu() {
        this.updateMenuState(true);
    }

    /**
     * close menu
     */
    closeMenu() {
        this.updateMenuState(false);
    }

    requestCloseSubMenu() {
        this.requestClose$.next(true);
    }

    menuOpenChange(isOpen: boolean, hasSecondaryNav: boolean): void {
        this.menuOpen$.next({ isOpen, hasSecondaryNav });
    }
}
